import { useEffect, useState } from "react";

function useInfiniteScroll(callback, threshold = 10, minScrollDiff = 50) {
    const [lastTriggerPoint, setLastTriggerPoint] = useState(0); 

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // 🔹 Scroll sonuna çatıb-çatmadığını yoxla
            if (windowHeight + scrollY >= documentHeight - threshold) {
                // 🔹 Sonuncu işləmə nöqtəsindən müəyyən məsafə keçibsə, yenidən işlə
                if (scrollY - lastTriggerPoint >= minScrollDiff) {
                    callback(); // ✅ Yeni məhsulları yüklə
                    setLastTriggerPoint(scrollY); // ✅ Son nöqtəni yadda saxla
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [callback, threshold, minScrollDiff, lastTriggerPoint]);

    return lastTriggerPoint; // Sonuncu işləmə nöqtəsini qaytarır
}

export default useInfiniteScroll;
